import { Space } from '@/Hooks/useRecommendation/useSpaceRecommendations'
import SearchEventCard from './SearchEventCard'

interface Props {
  spaces: Space[]
  selectedIds: number[]
  onToggle: (id: number) => void
  onCardClick?: (id: number) => void
}

const SearchVenueList = ({ spaces, selectedIds, onToggle, onCardClick }: Props) => (
  <div className='flex flex-col gap-4'>
    {spaces.map((space) => {
      const spaceId = Number(space.id)
      return (
        <SearchEventCard
          key={space.id}
          space={space}
          isSelected={selectedIds.includes(spaceId)}
          onSelect={() => onToggle(spaceId)}
          onCardClick={onCardClick ? () => onCardClick(spaceId) : undefined}
        />
      )
    })}
  </div>
)

export default SearchVenueList
